<template>
  <div class="snail_ending_page">
    <!-- 活动标题 -->
    <div v-wechat-title="wechatTitle"></div>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @downloadMonitor="downloadApp" />
    
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='selectCallback' :gameName="gameName" :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看" :channelDist="39">
    </Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell' :gameName="gameName">
    </Os>

    <!-- 结局内容页 -->
    <div :class="'snail-ending-content ending-content-' + page_type">
      <div class="title"></div>
      <div class="help" @click="popSwitch('findTeamShow', true)"></div>
      <div :class="'btn btn-' + help_status" @click="helpBtn()"></div>
    </div>

    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div
              class="btn qq-btn"
              data-snail-report-name="寻找搭子弹窗-去QQ"
              @click="toGroupOfQQ()"
            ></div>
            <div
              class="btn wechat-btn"
              data-snail-report-name="寻找搭子弹窗-去微信"
              @click="toGroupOfWechat()"
            ></div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="findTeamShow"
        @click="popSwitch('findTeamShow', false)"
      ></div>
    </div>

    <!-- 规则弹窗 -->
    <div :class="'rule-wrap popup_wrap rule-wrap-' + ruleShow" v-show="ruleShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box" v-show="ruleShow"><div class="close-btn" @click="popSwitch('ruleShow', false)"></div></div>
      </transition>
      <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
    </div>

    <!-- 非微信下分享引导弹窗 -->
    <div :class="'share-wrap popup_wrap share-wrap-' + shareShow" v-show="shareShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div>
          <div class="share-img-top"></div>
          <div class="share-img-bottom"></div>
        </div>
      </transition>
      <div class="close-bg" @click="popSwitch('shareShow', false)"></div>
    </div>

    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button
            class="monitor-btn"
            @click="onCopy('qq-clipboard-btn')"
            id="qq-clipboard-btn"
            data-snail-report-name="复制QQ群号"
            data-event="复制QQ群号"
            :data-clipboard-text="qqNumber"
          ></button>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="qqGroupShow"
        @click="popSwitch('qqGroupShow', false)"
      ></div>
    </div>

    <!-- 阻止点击弹出-弹窗 -->
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>
<script>

import Clipboard from "clipboard";
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import { headerConfig } from "../headerConfig";
import { onGetInitDataAPI, helpDataAPI, downloadApps } from '../api';
import { wechatBrowser, getRandomString, getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
import { set } from "lodash";
export default {
  name: 'ending',
  components: {
    Header,
    Login,
    Os
  },
  data() {
    return {
      count: 0, // 预加载进度-开发中关闭为100
      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password"],
      downloadUrl: 'http://snail.qingcigame.com/official/',
      taptapUrl: 'https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr',
      active_Info: {}, // 活动信息
      user_info: {}, // 用户信息
      page_type: '',
      qqNumber: '',
      isUserInfo: false, // 是否获取用户信息
      // 弹窗相关
      preventShow: false, // 阻止点击弹出
      wxLoadShow: false, //微信下载弹窗
      shareShow: false, // 分享弹窗
      rewardListShow: false, // 奖励信息弹窗
      copyFriendsShow: false, // 非微信下的邀请好友弹窗
      ruleShow: false, // 规则弹窗
      addShow: false, // 增加次数弹窗
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      // 默认下载包
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1169712.apk',
        ios_url: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1169724&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
      },
      url_type: '',
      code: '',
      auth_code: '',
      qq_link: '',
      url_scheme: '',
      help_status: false,
      wechatTitle: '',
    };
  },
  created() {
    setTimeout(() => {
      this.getLoginContainer();
      this.setInitActiveInfo();
      this.setInitUserInfo();
    }, 100);
    // 预加载
    this.isSetShare(false);
    const params = analysisParams(window.location.href);
    const { download_id } = params;
    const { type } = params;
    console.log('type', type);
    this.page_type = type;
    
    download_id && downloadApps({ download_id, title: 'title' }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      
      this.params = analysisParams(window.location.href);
      this.url_type = this.params.type;
      this.code = this.params.code;
      this.auth_code = this.params.auth_code;

      this.titleChange(this.url_type);  // 标题设置
      const bl = buriedLogger('snail', '蜗牛_结局h5');  // 埋点
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('蜗牛_结局h5_活动页统计');
      }, 200);
    })
  },
  methods: {
    titleChange(type) {
      const t = Number(type);
      const titles = {
        1: '【最强蜗牛】V我一个助力，共赴大雷音寺！',
        2: '【最强蜗牛】V我一个助力，看大电音寺在线蹦迪！',
        3: '【最强蜗牛】V我一个助力，与杀心观音坐莲论道！'
      };
      this.wechatTitle = titles[t] || '最强蜗牛';
    },
    helpBtn() {
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }
      this.preventShow = true;
      helpDataAPI(
        {
          type: this.url_type,
          code: this.code,
          auth_code: this.auth_code
        }
      ).then(response => {
        setTimeout(() => {
          this.preventShow = false;
        }, 1000);
        if (Number(response.code) === 200) {
          this.logger.sum('蜗牛_结局h5_点击助力解锁按钮');
          this.onToast(response.message);
          // 回调
          this.getLoginContainer(); 
          return
        }
        if (Number(response.code) === 406) {
          setTimeout(() => {
            this.popSwitch('shareShow', true);
          }, 2500);
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch((err) => {
        // this.onToast('服务器出错啦')
      })
    },
    // 获取用户信息
    getLoginContainer() {
      onGetInitDataAPI(
        {
          type: this.url_type,
          code: this.code,
          auth_code: this.auth_code
        }
      ).then(response => {
        if (Number(response.code) === 200) {
          this.active_Info = response.data.activity || [];
          this.user_info = response.data.user_info || [];
          this.qq_link = response.data.activity.qq_link;
          this.url_scheme = response.data.activity.url_scheme;
          this.help_status = response.data.activity.help_status;
          this.qqNumber = response.data.activity.qq;
          this.isSetShare(false);
          // 回调
          this.onInitDataCallback(response);  
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch((err) => {
        // this.onToast('服务器出错啦')
      })
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.popSwitch('findTeamShow', false);
        this.popSwitch('qqGroupShow', true);
      } else {
        setTimeout(() => {
          window.location.href = this.qq_link;
        }, 200);
      }
      this.logger.sum('蜗牛_结局h5_前往QQ群按钮');
    },
    toGroupOfWechat() {
      this.logger.sum('蜗牛_结局h5_前往微信群按钮');
      setTimeout(() => {
        window.location.href = this.url_scheme;
      }, 200);
    },
    // 点击下载
    downloadLink() {

      if (this.url_type == '' || this.url_type == undefined) {
        this.logger.sum('蜗牛_结局h5_点击首屏下载按钮');
        setTimeout(() => {
          window.location.href = this.taptapUrl;
        }, 200);
      } else {
        this.logger.sum('蜗牛_结局h5_点击首屏下载按钮(qc-kol-1145353)');
        setTimeout(() => {
          window.location.href = '//download4.qcplay.com/apk-v2/' + this.url_type + '.apk';
        }, 200);
      }

    },
    // 弹窗状态-开or关
    popSwitch(name, state) {
      // 奖励列表
      if ((name == 'findTeamShow' && state)) {
        if (this.user_info.account === undefined || this.user_info.account === '') {
          this.changeLoginPopup(true);
        } else {
          this.logger.sum('蜗牛_结局h5_寻找群友助力按钮');
          this[name] = state;
        }
        return
      }
      this[name] = state;
    },
    // 微信分享
    isSetShare(is_wx) {
      var enterLink = window.location.href;
      this.setShare({
        link: enterLink,
        title: '【最强蜗牛】V我一个助力，带你看新春活动花样结局！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/JHUCFMN8uGUxiTl4Yv2tuSZIASFgN49d85W8uz4N.jpeg',
        desc: '在线急等，速来微观！',
      })
    },
    // 选择角色后
    selectCallback() {
      this.clearActiveInfo();
      this.getLoginContainer();
    },
    // TAG: 相关业务方法
    onInvite() {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    // 注销
    osCancell() {
      this.clearActiveInfo();
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.active_Info = [];
      this.user_info = [];
      this.isUserInfo = true;
      this.help_status = false;
    },
    // 下载调用
    downloadApp () {
      const isWechat = wechatBrowser()
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        // const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;
        const targetLink = 'https://qcg.ink/5uXoV';
        this.logger.sum('蜗牛_结局h5_【下载】跳转按钮');

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    onCopy(id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on("success", (e) => {
        this.onToast(id === "thank-words" ? "密令复制成功" : "复制成功");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToast("复制失败");
      });
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 2000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 通用按钮缩放动画
    triggerBtnScale(e) {
      const el = e.currentTarget;
      el.classList.add('btn-scale-ani');
      this.preventShow = true;
      el.addEventListener('animationend', function handler() {
        el.classList.remove('btn-scale-ani');
        el.removeEventListener('animationend', handler);
      });
      setTimeout(() => { this.preventShow = false }, 250);
    },
    loginSuccess () {
      this.getLoginContainer();
    },
    loginCallback(response) {
      localStorage.setItem('nyf_token', response.data.access_token)
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
  computed: {
    
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          console.log('注销的时候')
          this.osCancell()
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          // 数据初始化
          // this.getLoginContainer()
        }
      }
    }
  },
};
</script>

<style lang="less">
@import url("./index.less");
</style>
 



// WEBPACK FOOTER //
// src/pages/snail/ending/index/index.vue